/* unplugin-vue-components disabled */import script from "./video-list.vue?vue&type=script&lang=jsx"
export * from "./video-list.vue?vue&type=script&lang=jsx"

import "./video-list.vue?vue&type=style&index=0&id=55f4009c&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f4009c"]])

export default __exports__